import { render, staticRenderFns } from "./questionCard.vue?vue&type=template&id=06a246a8&scoped=true"
import script from "./questionCard.vue?vue&type=script&lang=js"
export * from "./questionCard.vue?vue&type=script&lang=js"
import style0 from "./questionCard.vue?vue&type=style&index=0&id=06a246a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a246a8",
  null
  
)

export default component.exports